import {
  Button,
  Divider,
  IconButton,
  Stack,
  createStyles,
} from "@mui/material";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import AddIcon from "@mui/icons-material/Add";
import React, { useEffect, useState } from "react";
import { black } from "../../utils/StyleHelpers";
import { useContentStore } from "../../stores/contentStore";
import { locale } from "../../utils/LocaleManager";
import { useRolePermissionsStore } from "../../stores/rolePermissionsStore";
import IosShareOutlined from "@mui/icons-material/IosShareOutlined";

const buttonStyle = createStyles({
  color: black,
  textTransform: "none",
});

const TagsContextMenu = (props: any) => {
  const setIsShowAddTagDialog = useContentStore(
    (state: any) => state.setIsShowAddTagDialog,
  );

  return (
    <Stack
      direction={{ xs: "column", sm: "row" }}
      flexWrap={"wrap"}
      divider={<Divider orientation="vertical" flexItem />}
      style={{
        background: "#F0F4F8",
        borderRadius: "0.5rem",
        padding: "0.25rem",
        gap: "2.5rem",
        alignItems: "center",
        marginBottom: "2.5rem",
        marginTop: "1rem",
        marginLeft: "1rem",
      }}
      justifyContent={"center"}
    >
      <Stack direction="row" spacing={2}>
        <Button
          variant="text"
          style={buttonStyle}
          startIcon={<EditOutlinedIcon fontSize="small" />}
          onClick={props.onClickEdit}
          disabled={props?.isRowSelected === false}
          sx={{
            ":disabled": {
              opacity: "0.5",
            },
          }}
        >
          {locale.editTag}
        </Button>
        <Button
          variant="text"
          style={buttonStyle}
          startIcon={<AddIcon fontSize="small" />}
          onClick={() => setIsShowAddTagDialog(true)}
          sx={{
            ":disabled": {
              opacity: "0.5",
            },
          }}
        >
          {locale.add_tag}
        </Button>
      </Stack>
      <Stack
        direction={{ xs: "column", sm: "row" }}
        flexWrap={"wrap"}
        spacing={2}
      >
        <Button
          variant="text"
          style={buttonStyle}
          startIcon={<IosShareOutlined fontSize="small" />}
          onClick={props?.onClickExport}
        >
          {locale.exportTranscript}
        </Button>
      </Stack>
    </Stack>
  );
};

export default TagsContextMenu;
